/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import type { RootState } from "../app/store";
import { resetAuth } from "../reducers/authSlice";
import { generateEncryptedKeyBody, generateSEKAndHash } from "./crypto";
import { API_URL } from "../constants/url";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState).auth;
    const { tempToken } = (getState() as RootState).auth;

    const encryptData = generateSEKAndHash(token || tempToken || null);

    if (encryptData) {
      headers.set("hash", encryptData?.hash);
      headers.set("sek", encryptData?.sek);
      headers.set("devicetype", "WEB");
      headers.set("appKey", new Date().toISOString());
      headers.set("x-portal", "admin");
      // headers.set("authorization",`Bearer ${token}`)l
    }
    console.log(headers, "headers");

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  var body;
  // console.log(args, "args>>>>>>>>");

  if (args?.body) {
    body = generateEncryptedKeyBody(args?.body); // Encrypt request body if it exists
  }

  // Define data object based on presence of request body
  const data = args?.body
    ? { body, method: args.method, url: args.url }
    : { method: args.method, url: args.url };
  const result = await baseQuery(data, api, extraOptions);
  if (result.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    console.log(errors);

    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }
    if (errors?.length) {
      const error = errors[0] as any;
      if (error?.length) {
        console.log(error[0]);
      }
    }
  }

  if (result?.error?.status === 401) {
    api.dispatch(resetAuth());
    if (window) {
      window.location.replace("/");
    }
  }
  if (
    result.error &&
    result.error.status === 401 &&
    (api.getState() as RootState).auth.user
  ) {
    api.dispatch(resetAuth());
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "UNAUTHORIZED",
    "UNKNOWN_ERROR",
    "ADBANNER",
    "CMS",
    "DISCOUNT",
    "SERVICEMANAGEMENT",
  ],
  endpoints: () => ({}),
});

export default emptySplitApi;
